var _defs, _polyline, _polyline2, _line, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuduraWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a842aaec-4223-40d8-a381-85252e40f8c1",
    "data-name": "sudura",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 199.04 199.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a59e0206-724b-47ea-ae9e-a5c5811ba68e,.b7ed9737-b837-472c-9654-f2bf0ac5a2f0,.e19a2535-0138-4c92-84ae-ab211aa29274{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}.e19a2535-0138-4c92-84ae-ab211aa29274{stroke-width:10px;}.b7ed9737-b837-472c-9654-f2bf0ac5a2f0{stroke-width:2px;}.a59e0206-724b-47ea-ae9e-a5c5811ba68e{stroke-width:5px;}.bbc99cbd-46c6-44bc-b1c7-bd287bea70fb{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sudura_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "e19a2535-0138-4c92-84ae-ab211aa29274",
    points: "194.03 149.5 48.53 149.5 48.53 5"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "e19a2535-0138-4c92-84ae-ab211aa29274",
    points: "194.03 100 97.03 100 97.03 5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b7ed9737-b837-472c-9654-f2bf0ac5a2f0",
    x1: 98.04,
    y1: 100,
    x2: 49.04,
    y2: 149
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f8f35de7-8a01-4dde-a63c-bc508804f5ea",
    "data-name": "Arrow copy 2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a59e0206-724b-47ea-ae9e-a5c5811ba68e",
    x1: 2.5,
    y1: 121.54,
    x2: 36.78,
    y2: 155.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbc99cbd-46c6-44bc-b1c7-bd287bea70fb",
    d: "M9,150.78A1.76,1.76,0,0,1,11,149.45l26.14,5.8-5.8-26.14a1.75,1.75,0,1,1,3.42-.76l6.39,28.82a1.75,1.75,0,0,1-2.09,2.09l-28.82-6.39a1.86,1.86,0,0,1-.86-.47A1.78,1.78,0,0,1,9,150.78Z",
    transform: "translate(-0.96)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a59e0206-724b-47ea-ae9e-a5c5811ba68e",
    x1: 77.75,
    y1: 196.79,
    x2: 43.48,
    y2: 162.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbc99cbd-46c6-44bc-b1c7-bd287bea70fb",
    d: "M73.23,167.55a1.75,1.75,0,0,1-2.08,1.33L45,163.08l5.79,26.14a1.75,1.75,0,1,1-3.41.75L41,161.15a1.76,1.76,0,0,1,2.09-2.09l28.82,6.4a1.69,1.69,0,0,1,.86.47A1.73,1.73,0,0,1,73.23,167.55Z",
    transform: "translate(-0.96)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuduraWhite);
export default __webpack_public_path__ + "static/media/sudura_white.e93258d99e07e1bd7f141fb1b2e4b2e3.svg";
export { ForwardRef as ReactComponent };